// extracted by mini-css-extract-plugin
module.exports = {"statisticsContainer":"index_statisticsContainer__2_ETs","statisticContent":"index_statisticContent__1g3wi"};